/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  MwffFlowState_Enum,
  mwffFlowState_EnumFromJSON,
  mwffFlowState_EnumToJSON,
} from "../../../../gen/pose_polisher/mwff_flow_state";

export const protobufPackage = "skills";

export interface SpoofManualGpsActionArgs {
  hasHeading: boolean;
  hasAltitude: boolean;
  state: MwffFlowState_Enum;
}

export interface SpoofManualGpsResultData {
}

export interface SpoofManualGpsActionStateData {
}

function createBaseSpoofManualGpsActionArgs(): SpoofManualGpsActionArgs {
  return { hasHeading: false, hasAltitude: false, state: 0 };
}

export const SpoofManualGpsActionArgs = {
  encode(message: SpoofManualGpsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hasHeading === true) {
      writer.uint32(8).bool(message.hasHeading);
    }
    if (message.hasAltitude === true) {
      writer.uint32(16).bool(message.hasAltitude);
    }
    if (message.state !== 0) {
      writer.uint32(24).int32(message.state);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofManualGpsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofManualGpsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.hasHeading = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.hasAltitude = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofManualGpsActionArgs {
    return {
      hasHeading: isSet(object.hasHeading) ? globalThis.Boolean(object.hasHeading) : false,
      hasAltitude: isSet(object.hasAltitude) ? globalThis.Boolean(object.hasAltitude) : false,
      state: isSet(object.state) ? mwffFlowState_EnumFromJSON(object.state) : 0,
    };
  },

  toJSON(message: SpoofManualGpsActionArgs): unknown {
    const obj: any = {};
    if (message.hasHeading === true) {
      obj.hasHeading = message.hasHeading;
    }
    if (message.hasAltitude === true) {
      obj.hasAltitude = message.hasAltitude;
    }
    if (message.state !== 0) {
      obj.state = mwffFlowState_EnumToJSON(message.state);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofManualGpsActionArgs>, I>>(base?: I): SpoofManualGpsActionArgs {
    return SpoofManualGpsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofManualGpsActionArgs>, I>>(object: I): SpoofManualGpsActionArgs {
    const message = createBaseSpoofManualGpsActionArgs();
    message.hasHeading = object.hasHeading ?? false;
    message.hasAltitude = object.hasAltitude ?? false;
    message.state = object.state ?? 0;
    return message;
  },
};

function createBaseSpoofManualGpsResultData(): SpoofManualGpsResultData {
  return {};
}

export const SpoofManualGpsResultData = {
  encode(_: SpoofManualGpsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofManualGpsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofManualGpsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofManualGpsResultData {
    return {};
  },

  toJSON(_: SpoofManualGpsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofManualGpsResultData>, I>>(base?: I): SpoofManualGpsResultData {
    return SpoofManualGpsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofManualGpsResultData>, I>>(_: I): SpoofManualGpsResultData {
    const message = createBaseSpoofManualGpsResultData();
    return message;
  },
};

function createBaseSpoofManualGpsActionStateData(): SpoofManualGpsActionStateData {
  return {};
}

export const SpoofManualGpsActionStateData = {
  encode(_: SpoofManualGpsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofManualGpsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofManualGpsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofManualGpsActionStateData {
    return {};
  },

  toJSON(_: SpoofManualGpsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofManualGpsActionStateData>, I>>(base?: I): SpoofManualGpsActionStateData {
    return SpoofManualGpsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofManualGpsActionStateData>, I>>(_: I): SpoofManualGpsActionStateData {
    const message = createBaseSpoofManualGpsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
